//fire
function Header(props) {
  return (
    <header class="topBar">
    <h1 class="headerTxt">Crypto Tabs UI</h1>
  </header>
  )

}

export default Header